import { Box, createStyles } from '@mantine/core';
import { memo } from 'react';
import { DOCUMENTATION_WIDTH } from '../../../components/Documentation/constants';

const useStyles = createStyles(() => ({
	container: {
		width: '100%',
		maxWidth: `${DOCUMENTATION_WIDTH}px`,
		margin: '0 auto',
	},
}));

export const ViewportWrapper = memo(
	({ children }: { children: React.ReactNode }) => {
		const { classes } = useStyles();

		return <Box className={classes.container}>{children}</Box>;
	}
);
